import React from "react";

const formatDate = (date) => {
    if (!date) return "";

    const d = new Date(date);

    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;

    return `${month}/${day}, ${hours}:${minutes} ${ampm}`;
};

const OneCardResult = ({ resultData = [] }) => {

    return (

        <div className="left-content">

            {resultData.map((row, index) => {

                const players = [
                    {
                        label: row.cat_rnr1 || "Player",
                        card: row.ac1,
                        winner: String(row.result) === "1"
                    },
                    {
                        label: row.cat_rnr2 || "Dealer",
                        card: row.ac2,
                        winner: String(row.result) === "2"
                    }
                ];

                return (

                    <div
                        key={index}
                        className="card"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "10px",
                            marginBottom: "8px",
                            background:
                                "linear-gradient(rgb(15,15,15), rgb(251,251,251))"
                        }}
                    >

                        <div
                            style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                                marginBottom: "15px", marginLeft: "10px", marginTop: "8px"
                            }}
                        >
                            {formatDate(row.evt_od)} - <b>ID= </b>
                            {row.evt_id || row.cat_mid}
                        </div>

                        <div
                            class="only-mob"
                            style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                gap: "15px",
                                flexWrap: "wrap"
                            }}
                        >

                            {players.map((player, i) => (

                                <div
                                    key={i}
                                    style={{
                                        width: "290px",
                                        borderRadius: "10px",
                                        overflow: "hidden",
                                        background: player.winner
                                            ? "green"
                                            : "#555"
                                    }}
                                >

                                    <div
                                        style={{
                                            textAlign: "center",
                                            fontWeight: "bold",
                                            color: "#fff"
                                        }}
                                    >
                                        {player.label}
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            minHeight: "65px"
                                        }}
                                    >

                                        {player.card ? (

                                            <img
                                                src={`/assets/images/cards/${player.card}.svg`}
                                                alt=""
                                                draggable={false}
                                                style={{
                                                    width: "45px"
                                                }}
                                            />

                                        ) : (

                                            <div
                                                style={{
                                                    width: "45px",
                                                    height: "62px"
                                                }}
                                            />

                                        )}

                                    </div>

                                    <div
                                        style={{
                                            background: player.winner
                                                ? "#cf8d2e"
                                                : "#cf3f3f",
                                            color: "#000",
                                            textAlign: "center",
                                            fontWeight: "bold",
                                            borderRadius: "10px"
                                        }}
                                    >
                                        {player.winner
                                            ? "WINNER"
                                            : "LOSER"}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
            <style>
                {`
                @media(max-width:576px){
                    .only-mob {
                        display: flex !important;
                        justify-content: space-between !important;
                        align-items: stretch !important;
                        gap: 5px !important;
                        width: 100% !important;
                    }
                    .only-mob > div {
                flex: 1 1 0 !important;
                min-width: 0 !important;
                width: auto !important;
            }
                }
                `}
            </style>
        </div>
    );
};

export default OneCardResult;